import { DebugLogger } from "@ng-mw/shared-react-components"

// Temporary fix for Old Native Wrapper not responding to fetchTokenFromNative
const fetchTokenFromNativeError = () =>
    new Promise((resolve: (token: null) => void) => {
        setTimeout(() => {
            DebugLogger.log("Load-order-debug: fetchTokenFromNativeError done")
            resolve(null)
        }, 12000) // 12 seconds to allow for lots of retries in the wrapper
    })

export default fetchTokenFromNativeError
